import React, { useState } from "react";
import styles from "./IntegrationList.module.sass";
import cn from "classnames";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Filters from "../../components/Filters";
import Settings from "./Settings";
import Table from "./Table";
import Panel from "./Panel";
import Details from "./Details";

const navigation = ["Active", "New"];

const IntegrationList = () => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [search, setSearch] = useState("");
	const [visible, setVisible] = useState(false);
	const [detailData, setDetailData] = useState({
		title: "",
		avatar: "",
	});

	const handleSubmit = (e) => {
		alert();
	};

	return (
		<>
			<Card
				className={styles.card}
				title="Integrations"
				classTitle={cn("title-purple", styles.title)}
				classCardHead={cn(styles.head, { [styles.hidden]: visible })}
				// head={
				// 	<>
				// 		<Form
				// 			className={styles.form}
				// 			value={search}
				// 			setValue={setSearch}
				// 			placeholder="Search by integration name"
				// 			type="text"
				// 			name="search"
				// 			icon="search"
				// 		/>
				// 	</>
				// }
			>
				<div className={cn(styles.row, { [styles.flex]: visible })}>
					<Table
						className={styles.table}
						activeTable={visible}
						setActiveTable={setVisible}
						setData={setDetailData}
					/>
					<Details
						className={styles.details}
						data={detailData}
						onClose={() => setVisible(false)}
					/>
				</div>
			</Card>
		</>
	);
};

export default IntegrationList;
